module.exports = __webpack_public_path__ + "static/img/1_4.984d8e8d.jpg";